export default {
  switchAccount: "切换账号",
  login: "登录",
  loginFirst: "请先登录账号",
  start: "开始答题",
  hasHistory: "您之前已经回答了部分题目，",
  loadHistory: "是否继续上次回答？",
  cancel: "取消",
  confirm: "确认",
  contact: "填写联系方式有几率获得额外奖励喔！",
  completed: "恭喜您完成了问卷",
  leaveMessage: "留下您的联系方式可获得抽奖机会",
  enterEmail: "请输入您的电子邮箱：",
  enterPhone: "请输入您的手机号码：",
  submit: "提交",
  leave: "暂填写，离开问卷",
  submitted: "已提交，",
  thanks: "感谢您的信任与支持",
  opinion: "请谈谈您的想法",
  prev: "上一题",
  next: "下一题",
  unlikely: "不可能",
  likely: "极有可能",
  claimYourRewards: "这是给您的奖励",
  rewardSent: "奖励已发放",
  checkInGame: "请进入游戏内查看",
  copy: "复制",
  copied: "复制成功",
  selectTips: "请选择选项",
  multipleTips: "此题为多选题，请选择多个选项",
  leastChoose: "最多选择xxx项",
  maxChoose: "最少选择xxx项",
  mustAnswer: "请回答此题",
  mustWrite: "请填写内容",
  checkEmail: "请输入正确格式的电子邮箱",
  checkPhone: "请输入正确格式的手机号码",
  isAnswer: "您已答题",
  unStart: "活动未开启",
  end: "活动已结束",
  server: "请选择伺服器",
  role: "请选择角色",
  common: "系统繁忙，请稍后再试",
  title: "问卷调查",
  titleAward: "有奖调查",
  leastWord: "您的输入小于最小输入字数xxx",
  maxWord: "您的输入已超过最大字数xxx",
  singleChoose: "单选",
  multiChoose: "多选",
  matrix: "矩阵题",
  score: "评分题",
  textLimit: "(xx-yyy字)",
  coverGiftTitle: "填问卷领豪礼",
  "-20001": "未登录",
  "-20002": "缺少必要参数",
  "-20003": "找不到问卷",
  "-20004": "问卷配置中",
  "-20005": "问卷已停止",
  "-20006": "问卷活动未开始",
  "-20007": "问卷活动已结束",
  "-20008": "已经答题",
  "-20010": "发奖失败",
  "-20011": "该问卷已经发奖",
  "-20012": "还未答题",
  "-20016": "游戏ID无效",
};
